export default function contentfulDeafultLoader({
  src,
  width,
  quality = `${Number(process.env.IMG_QUALITY ?? 60)}`,
}: {
  src: string;
  width: number;
  quality?: number | `${number}`;
}) {
  try {
    // Local static assets (e.g. /icons/*.png) aren't absolute URLs and can't be transformed via query params
    if (src.startsWith("/")) return src;
    if (!src.includes(".svg")) {
      const url = new URL(src);
      url.searchParams.set("fm", "webp");
      url.searchParams.set("w", width.toString());
      url.searchParams.set("q", quality.toString());
      url.searchParams.set("fit", "fill");
      return url.href;
    }
    return src;
  } catch (error) {
    console.error(error);
  }
}

export interface ImageTransformOptions {
  src: string;
  width: number; // Larghezza dell'immagine (max 4000px)
  height?: number; // Altezza dell'immagine (max 4000px)
  quality?: number; // Qualità dell'immagine (1-100)
  format?: "jpg" | "png" | "webp" | "gif" | "avif" | "tiff";
  fit?: "pad" | "fill" | "scale" | "crop" | "thumb"; // Tipo di ridimensionamento
  focus?: "center" | "top" | "right" | "left" | "bottom" | "top_right" | "top_left" | "bottom_right" | "bottom_left" | "face" | "faces"; // Area di focus
  cornerRadius?: number | "max"; // Per angoli arrotondati o ellissi
  backgroundColor?: string; // Colore di sfondo (per fit pad o angoli arrotondati)
  progressive?: boolean; // Per immagini JPEG progressive
}
/**
 * https://www.contentful.com/developers/docs/references/images-api/
 * @param
 */
export const contentfulImageLoader = ({
  src,
  width,
  height,
  quality = parseInt(process?.env?.IMG_QUALITY ?? "80", 10) ?? 80,
  format = "webp",
  fit = "fill",
  focus,
  cornerRadius,
  backgroundColor,
  progressive,
}: ImageTransformOptions) => {
  try {
    const queryStart = src.indexOf("?");
    const hashStart = src.indexOf("#");
    const suffixStart = queryStart >= 0 && (hashStart < 0 || queryStart < hashStart) ? queryStart : hashStart;
    const baseUrl = suffixStart >= 0 ? src.slice(0, suffixStart) : src;
    const existingQuery = queryStart >= 0 ? src.slice(queryStart + 1, hashStart >= 0 ? hashStart : undefined) : "";
    const hash = hashStart >= 0 ? src.slice(hashStart) : "";
    const params = new URLSearchParams(existingQuery);

    if (src && !src.includes(".svg")) {
      if (format) params.set("fm", format);
      if (progressive) params.set("fl", "progressive");
    } else {
      params.set("fm", "webp");
    }
    if (width) params.set("w", width.toString());
    if (height) params.set("h", height.toString());
    if (fit) params.set("fit", fit);
    if (focus) params.set("f", focus);
    if (cornerRadius) params.set("r", cornerRadius === "max" ? "max" : cornerRadius.toString());
    if (quality) params.set("q", quality.toString());
    if (backgroundColor) params.set("bg", backgroundColor);
    return `${baseUrl}?${params.toString()}${hash}`;
  } catch (error) {
    console.error(error);
  }
};
